import {
    BaseEntity,
    Entity as DecribeEntity,
    Relation,
    RelationList,
} from '@avangard/utils/entity';

import { FileInfoEntity } from '@modules/shared/entities';
import { StudentProfileGroupType } from '@modules/types/graphql';
import { StudentProfileGroupEntityList } from './student-profile-group.entity-list';
import { StudentProfileGroupEntity } from './student-profile-group.entity';

import type { StudentProfile } from '@modules/types/graphql';

export type Entity = StudentProfile | null;

@DecribeEntity('StudentProfileEntity')
class StudentProfileEntity extends BaseEntity {
    id: string;
    fullName: string;
    qrCodeUrl: string;

    @Relation(() => FileInfoEntity)
    photo: FileInfoEntity;

    @RelationList(() => StudentProfileGroupEntityList)
    groups: StudentProfileGroupEntity[];

    constructor(student: Entity) {
        super(student);

        this.id = student?.id ?? '';
        this.fullName = student?.fullName ?? '';
        this.qrCodeUrl = student?.qrCodeUrl ?? '';
    }

    getSummaryGroup() {
        const result = this.groups.find(group => group.type === StudentProfileGroupType.summary);

        if (!result) {
            return new StudentProfileGroupEntity({});
        }

        return result;
    }

    getEducationGroup() {
        const result = this.groups.find(group => group.type === StudentProfileGroupType.education);

        if (!result) {
            return new StudentProfileGroupEntity({});
        }

        return result;
    }

    getParentsGroup() {
        const result = this.groups.find(group => group.type === StudentProfileGroupType.parents);

        if (!result) {
            return new StudentProfileGroupEntity({});
        }

        return result;
    }

    getMedicalGroup() {
        const result = this.groups.find(group => group.type === StudentProfileGroupType.medical);

        if (!result) {
            return new StudentProfileGroupEntity({});
        }

        return result;
    }

    getSpecialsGroup() {
        const result = this.groups.find(group => group.type === StudentProfileGroupType.specials);

        if (!result) {
            return new StudentProfileGroupEntity({});
        }

        return result;
    }
}

export { StudentProfileEntity };
